import { render, staticRenderFns } from "./BeefCattleCalfForm.vue?vue&type=template&id=25a560ab"
import script from "./BeefCattleCalfForm.vue?vue&type=script&lang=js"
export * from "./BeefCattleCalfForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports